import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import logo from "../../assets/images/logo/dodeal-white.png";
// import TopBar from "../../components/Navbar/TopBar";

import { BsList } from "react-icons/bs";
import {
  RxCross1
} from "react-icons/rx";


function Header({ routes }) {
    const [openNav, setOpenNav] = useState(false);

    return (
        <div className="w-full padding-container flex items-center justify-between gap-5">
            <img src={logo} alt="DoDeal" className="w-[80px]" />
            {openNav ? (
                <RxCross1
                    size={28}
                    className="p-1.5 rounded-full border border-gray-500 text-gray-500 z-50 cursor-pointer"
                    onClick={() => setOpenNav(false)}
                />
            ) : (
                <BsList
                    size={28}
                    className="p-1.5 rounded-full border border-gray-500 text-gray-500 z-50 cursor-pointer"
                    onClick={() => setOpenNav(true)}
                />
            )}

            {/* {openNav && (
                <TopBar
                    openNav={openNav}
                    setOpenNav={setOpenNav}
                    routes={routes}
                />
            )} */}
        </div>
    );
}

export default Header;
